export const sizes = { SCALAR: 1, VEC2: 2, VEC3: 3, VEC4: 4 };
